import React, { useEffect, useState, useContext } from 'react'
import axios from 'axios'
import { RouteComponentProps } from 'react-router-dom'
import queryString from 'query-string'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import store from '../store'
import {
  setSearchQueryMessages,
  unsetSearchQueryMessages
} from '../store/actions/searchQueryMessages'
import FlatPagination from 'material-ui-flat-pagination'
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Chip,
  TextField,
  Typography,
  Checkbox,
  FormControl,
  FormGroup,
  FormControlLabel,
  Badge,
  Link
} from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import CancelIcon from '@material-ui/icons/Close'
import { ErrorRounded } from '@material-ui/icons'
import Title from '../components/atoms/Title'
import CheckBoxes from '../components/atoms/CheckBoxes'
import SelectInputTableHead from '../components/atoms/SelectInputTableHead'
import CreateMessageModal from '../components/organisms/CreateMessageModal'
import { User } from '../types/User'
import ConfigContext from '../ConfigContext'
import MessageAllHistoryModal from '../components/organisms/MessageAllHistoryModal'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: `100%`
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalPaper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  badge: {
    '& .MuiBadge-badge': {
      height: 'auto',
      padding: 3,
      borderRadius: '50%',
      backgroundColor: '#FF6363',
      color: '#fff'
    }
  },
  searchLabel: {
    maxWidth: '142px'
  },
  searchItem: {
    '@media (min-width: 1056px)': {
      flexGrow: 1,
      maxWidth: 'none',
      flexBasis: 'none'
    }
  }
}))

type UserWithMessageInfo = User & { unread: number; user_unread: number; message_count: number }

type MessageUserSearchResponse = {
  number_of_hits: number
  users: UserWithMessageInfo[]
  app_name: string
  unread_total: number
}

// データ取得apiのクエリー
type QueryString = {
  sort?: string
  order?: 'asc' | 'desc'
  page?: string
  kaiin_no?: string
  name?: string
  affiliation?: string
  message?: string
  unread?: boolean
  user_unread?: boolean
  unreadfilter?: string
  user_unreadfilter?: string
}
// urlのみで保持するクエリー。
// messagefilter:ページングでのフィルター保持のため
// pagescroll:ページスクロール位置1=検索結果に移動
type UrlQueryString = QueryString & {
  messagefilter?: string
  pagescroll?: string
}
type SearchCheckboxes = { checked: boolean; label: string; value: any }[]

const searchMessage: SearchCheckboxes = [
  { checked: false, label: '履歴あり', value: '1' },
  { checked: false, label: '履歴なし', value: '0' }
]
const asQueryString = {
  message: { init: 'message', filter: 'messagefilter' },
  unread: { init: 'unreadfilter', filter: 'unreadfilter' },
  user_unread: { init: 'user_unreadfilter', filter: 'user_unreadfilter' }
}

const Messages: React.FC<
  RouteComponentProps<{}> &
    ReturnType<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps>
> = ({ history, location, setSearchQuery, unsetSearchQuery, searchQuery }) => {
  // ページをロードした瞬間の初期クエリストリング
  const initQuery: UrlQueryString = queryString.parse(location.search)

  const classes = useStyles({})
  const [users, setUsers] = useState<UserWithMessageInfo[]>([])
  const [modalState, setModalState] = useState(false)
  const [messageAllHistoryModalState, setMessageAllHistoryModalState] = useState(false)
  const [keyword, setKeyword] = useState<{
    kaiin_no: string
    name: string
    affiliation: string
    message: string
  }>({
    kaiin_no: initQuery.kaiin_no || '',
    name: initQuery.name || '',
    affiliation: initQuery.affiliation || '',
    message: initQuery.message || ''
  })
  const [filter, setFilter] = useState<{
    message: string
    unread: string
    user_unread: string
  }>({
    message: initQuery.messagefilter || '',
    unread: initQuery.unreadfilter || '',
    user_unread: initQuery.user_unreadfilter || ''
  })
  const [total, setTotal] = useState<number>(0)
  const [limit, setLimit] = useState<number>(100)
  const [selectUsers, setSelectUsers] = useState<UserWithMessageInfo[]>([])
  const [storedUsers, setStoredUsers] = useState<UserWithMessageInfo[]>([])
  const [allChecked, setAllChecked] = useState<boolean>(false)
  const [onlyUnreadFlg, setOnlyUnreadFlg] = useState<boolean>(Boolean(initQuery.unread) || false)
  const [onlyUserUnreadFlg, setOnlyUserUnreadFlg] = useState<boolean>(
    Boolean(initQuery.user_unread) || false
  )
  const [sendToChecked, setSendToChecked] = useState<boolean>(false)
  const [checkedMessageCount, setCheckedMessageCount] = useState<SearchCheckboxes>(searchMessage)
  const config = useContext(ConfigContext)
  const [appName, setAppName] = React.useState('')
  const [unreadMessage, setUnreadMessage] = useState<number>(0)

  const fetchUsers = async (params: QueryString) => {
    const { data } = await axios.get<MessageUserSearchResponse>('/messages/users/search', {
      params: { ...params }
    })
    setUsers(data.users)
    setTotal(data.number_of_hits)
    setAppName(data.app_name)
    setUnreadMessage(data.unread_total)
    if (data.number_of_hits > 0) {
      setLimit(100)
    } else {
      setLimit(0)
    }
    setSelectUsers([])
    setAllChecked(false)
    setSendToChecked(false)
  }

  const fetchUnread = async () => {
    setFilter({ ...filter, unread: '1' })
    history.push({
      pathname: '/messages',
      search: queryString.stringify({ page: '1', unreadfilter: '1' })
    })
    await fetchUsers({ page: '1', unreadfilter: '1' })
    // 検索結果にスクロール移動する
    scrollPageSearchResults()
  }

  useEffect(() => {
    // console.log('初期化処理')
    try {
      if (
        searchQuery.page ||
        searchQuery.kaiin_no ||
        searchQuery.name ||
        searchQuery.affiliation ||
        searchQuery.message ||
        searchQuery.unread ||
        searchQuery.user_unread ||
        searchQuery.unreadfilter ||
        searchQuery.messagefilter
      ) {
        const query: QueryString = { ...searchQuery }
        history.push({
          pathname: '/messages',
          search: queryString.stringify(searchQuery)
        })
        setKeyword({ ...searchQuery })
        // フィルターの表示制御
        // 検索の「事務局の未読のみ表示」がtrue（チェックオン）のとき、事務局未読フィルターも未読ありにする
        // 検索の「ユーザーの未読のみ表示」がtrue（チェックオン）のとき、事務局未読フィルターも未読ありにする
        let filter = {
          message: searchQuery.messagefilter,
          unread: searchQuery.unread ? '1' : searchQuery.unreadfilter,
          user_unread: searchQuery.user_unread ? '1' : searchQuery.user_unreadfilter
        }
        // 検索のメッセージ履歴有無が選択されているとき
        if (searchQuery.message) {
          // 検索のメッセージ履歴チェックボックス表示制御
          setCheckedMessageCount(
            searchMessage.map(s =>
              s.value === searchQuery.message ? { ...s, checked: true } : { ...s }
            )
          )
          // フィルターのメッセージ履歴にも条件をセット
          filter.message = searchQuery.message
        }
        setFilter(filter)
        // メッセージ履歴フィルターはデータ取得クエリーのmessageを使用する
        if (query['messagefilter']) {
          query.message = query['messagefilter']
          delete query['messagefilter']
        }
        fetchUsers(query)
      } else {
        // お知らせの未読メッセージリンクから遷移したとき
        if (initQuery.unreadfilter === '1' && initQuery.pagescroll === '1') {
          fetchUnread()
        } else {
          fetchUsers({})
        }
      }
      unsetSearchQuery()
      // 検索結果にスクロール移動する
      if (initQuery.pagescroll === '1') scrollPageSearchResults()
      delete initQuery['pagescroll']
    } catch (error) {
      alert(error.message)
    }
  }, [])

  const scrollPageTop = () =>
    document.getElementById('main-content').scroll({
      top: 0,
      left: 0
    })

  const scrollPageSearchResults = () => {
    document.getElementById('top-of-list').scrollIntoView()
  }

  const handlePageChange = async (page: number) => {
    try {
      const query: QueryString = {
        page: String(page)
      }
      // ページ遷移するときはクエリストリングで指定された、検索文字を
      // 引き継ぐようにする
      if (initQuery.kaiin_no) {
        query.kaiin_no = initQuery.kaiin_no
        setKeyword({ ...keyword, kaiin_no: initQuery.kaiin_no })
      }
      if (initQuery.name) {
        query.name = initQuery.name
        setKeyword({ ...keyword, name: initQuery.name })
      }
      if (initQuery.affiliation) {
        query.affiliation = initQuery.affiliation
        setKeyword({ ...keyword, affiliation: initQuery.affiliation })
      }
      if (initQuery.message) {
        query.message = initQuery.message
        setKeyword({ ...keyword, message: initQuery.message })
      }
      if (onlyUnreadFlg) {
        query.unread = true
      }
      if (onlyUserUnreadFlg) {
        query.user_unread = true
      }
      if (initQuery.messagefilter) {
        query.message = initQuery.messagefilter
      }
      if (initQuery.unreadfilter) {
        query.unreadfilter = initQuery.unreadfilter
      }
      if (initQuery.user_unreadfilter) {
        query.user_unreadfilter = initQuery.user_unreadfilter
      }
      delete initQuery['pagescroll']
      history.push({
        pathname: '/messages',
        search: queryString.stringify({ ...initQuery, page: String(page) })
      })
      scrollPageTop()
      await fetchUsers(query)
    } catch (error) {
      alert(error.message)
    }
  }

  const handleSearch = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault()
      const query: QueryString = {}
      for (let key in keyword) {
        if (keyword[key]) {
          query[key] = keyword[key]
        }
      }
      if (onlyUnreadFlg) {
        query.unread = true
      }
      if (onlyUserUnreadFlg) {
        query.user_unread = true
      }
      // フィルター表示制御。共通する項目があれば表示を反映する
      // 検索の「事務局の未読のみ表示」がtrue（チェックオン）のとき、事務局未読フィルターも未読ありにする
      // 検索の「ユーザーの未読のみ表示」がtrue（チェックオン）のとき、事務局未読フィルターも未読ありにする
      setFilter({
        message: keyword.message || '',
        unread: onlyUnreadFlg ? '1' : '',
        user_unread: onlyUserUnreadFlg ? '1' : ''
      })
      history.push({
        pathname: '/messages',
        search: queryString.stringify(query)
      })
      scrollPageTop()
      await fetchUsers(query)
    } catch (error) {
      alert(error.message)
    }
  }

  const handleSearchReset = async () => {
    try {
      history.push({
        pathname: '/messages'
      })
      scrollPageTop()
      await fetchUsers({})
      setKeyword({
        kaiin_no: '',
        name: '',
        affiliation: '',
        message: ''
      })
      setCheckedMessageCount(searchMessage)
      setOnlyUnreadFlg(false)
      setOnlyUserUnreadFlg(false)
      setSendToChecked(false)
      setFilter({ message: '', unread: '', user_unread: '' })
    } catch (error) {
      alert(error.message)
    }
  }

  const handleFilter = async (key: string, select: string) => {
    try {
      delete initQuery['pagescroll']
      const urlQuery: UrlQueryString = { ...initQuery }
      // フィルター解除のとき、既存の検索条件に存在すれば削除する
      if (!select && urlQuery[asQueryString[key].filter]) {
        delete urlQuery[asQueryString[key].filter]
      }
      // メッセージ履歴のフィルター解除のとき、検索にチェックがあればクリアする
      if (key === 'message') {
        if (urlQuery[key]) delete urlQuery[key]
        setKeyword({ ...keyword, message: '' })
        setCheckedMessageCount(searchMessage)
      }
      // 事務局の未読フィルターをかけたとき、検索の事務局未読ユーザーのみにチェックがあればクリアする
      if (key === 'unread' && urlQuery.unread) {
        delete urlQuery.unread
        setOnlyUnreadFlg(false)
      }
      // ユーザーの未読フィルターをかけたとき、検索の未読ユーザーのみにチェックがあればクリアする
      if (key === 'user_unread' && urlQuery.user_unread) {
        delete urlQuery.user_unread
        setOnlyUserUnreadFlg(false)
      }
      // 既存の検索条件をデータ取得用にセット
      const query: QueryString = {}
      for (let queryKey in urlQuery) {
        if (queryKey === asQueryString.message.filter) {
          // メッセージ履歴
          query[asQueryString.message.init] = urlQuery[queryKey]
        } else {
          query[queryKey] = initQuery[queryKey]
        }
      }
      // フィルターをかけるとき
      if (select) {
        urlQuery[asQueryString[key].filter] = select
        query[asQueryString[key].init] = select
      }
      urlQuery.page = '1'
      query.page = '1'
      history.push({
        pathname: '/messages',
        search: queryString.stringify(urlQuery)
      })
      setFilter({ ...filter, [key]: select })
      await fetchUsers(query)
    } catch (error) {
      alert(error.message)
    }
  }

  const handleFilterReset = async () => {
    try {
      // フィルターおよび共通の検索項目はクエリーから除く
      const {
        message,
        unread,
        user_unread,
        unreadfilter,
        user_unreadfilter,
        messagefilter,
        pagescroll,
        ...query
      }: UrlQueryString = initQuery
      history.push({
        pathname: '/messages',
        search: queryString.stringify(query)
      })
      await fetchUsers(query)
      // フィルターと共通の検索項目をクリア
      setKeyword({
        ...keyword,
        message: ''
      })
      setCheckedMessageCount(searchMessage)
      setOnlyUnreadFlg(false)
      setOnlyUserUnreadFlg(false)
      setSendToChecked(false)
      // フィルターをクリア
      setFilter({ message: '', unread: '', user_unread: '' })
    } catch (error) {
      alert(error.message)
    }
  }

  const handleCheck = async (userId: number) => {
    const _selectUsers = [...selectUsers]
    if (_selectUsers.some(user => user.id === userId)) {
      setSelectUsers(_selectUsers.filter(user => user.id !== userId))
    } else {
      _selectUsers.push(users.filter(user => user.id === userId)[0])
      setSelectUsers(_selectUsers)
    }
  }

  const handleAllCheck = async () => {
    if (allChecked) {
      setSelectUsers([])
      setAllChecked(false)
    } else {
      setSelectUsers(users)
      setAllChecked(true)
    }
  }

  const handleCreateMessages = async () => {
    setSendToChecked(true)
    setStoredUsers(selectUsers)
    setModalState(true)
  }

  const handleMessageAllHistoryModal = () => {
    setMessageAllHistoryModalState(true)
  }

  const handleCreateMessagesForAllUsers = async () => {
    try {
      const query: QueryString = {}
      if (initQuery.kaiin_no) {
        query.kaiin_no = initQuery.kaiin_no
      }
      if (initQuery.name) {
        query.name = initQuery.name
      }
      if (initQuery.affiliation) {
        query.affiliation = initQuery.affiliation
      }
      if (initQuery.unread) {
        query.unread = true
      }
      if (initQuery.user_unread) {
        query.user_unread = true
      }
      if (initQuery.message) {
        query.message = initQuery.message
      }
      if (initQuery.unreadfilter) {
        query.unreadfilter = initQuery.unreadfilter
      }
      if (initQuery.user_unreadfilter) {
        query.user_unreadfilter = initQuery.user_unreadfilter
      }
      // console.log(query)
      const { data } = await axios.get<{
        number_of_hits: number
        users: UserWithMessageInfo[]
      }>('/messages/users/search-limitless', {
        params: query
      })
      setSendToChecked(false)
      setStoredUsers(data.users)
      setModalState(true)
    } catch (error) {
      alert(error.message)
    }
  }

  const closeHandler = async () => {
    const query: QueryString = {}
    if (initQuery.kaiin_no) {
      query.kaiin_no = initQuery.kaiin_no
    }
    if (initQuery.name) {
      query.name = initQuery.name
    }
    if (initQuery.affiliation) {
      query.affiliation = initQuery.affiliation
    }
    if (initQuery.unread) {
      query.unread = true
    }
    if (initQuery.user_unread) {
      query.user_unread = true
    }
    if (initQuery.message) {
      query.message = initQuery.message
    }
    if (initQuery.unreadfilter) {
      query.unreadfilter = initQuery.unreadfilter
    }
    if (initQuery.user_unreadfilter) {
      query.user_unreadfilter = initQuery.user_unreadfilter
    }
    if (initQuery.page) {
      query.page = initQuery.page
    }
    const { data } = await axios.get<MessageUserSearchResponse>('/messages/users/search', {
      params: { ...query }
    })
    setUsers(data.users)
    setTotal(data.number_of_hits)
    if (data.number_of_hits > 0) {
      setLimit(100)
    } else {
      setLimit(0)
    }
    if (sendToChecked) {
      setSelectUsers(storedUsers)
    }
    setAllChecked(false)
  }

  const saveQuery = () => {
    setSearchQuery(
      initQuery.page,
      initQuery.kaiin_no,
      initQuery.name,
      initQuery.affiliation,
      initQuery.message,
      initQuery.unread,
      initQuery.user_unread,
      initQuery.messagefilter,
      initQuery.unreadfilter,
      initQuery.user_unreadfilter
    )
  }

  const currentPageCaption = () => {
    const totalNumber = total
    const currentPage = Number(initQuery.page) || 1
    const totalPage = Math.ceil(total / limit)
    const startNumber = totalNumber === 0 ? 0 : (currentPage - 1) * limit + 1
    const lastNumber = currentPage === totalPage ? totalNumber : currentPage * limit
    return (
      <Typography variant="caption" align="center" display="block" color="primary">
        全 {totalNumber} 件｜ ({startNumber} - {lastNumber}件)
      </Typography>
    )
  }

  console.log(filter)

  return (
    <React.Fragment>
      {unreadMessage > 0 && (
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ErrorRounded color="error" style={{ marginRight: 2, marginBottom: 2 }} />
                会員より新しいメッセージが届いています。（
                <Link
                  onClick={async () => {
                    await handleFilter('unread', '1')
                    scrollPageSearchResults()
                  }}
                >
                  未読{unreadMessage}件
                </Link>
                ）
              </div>
            </Typography>
          </Paper>
        </Grid>
      )}

      <Grid item xs={12}>
        <Paper className={classes.paper} square elevation={2}>
          <Title>メッセージ</Title>
          <Typography variant="body1" paragraph>
            {config.serviceName}
            の利用登録を完了したユーザーのみ（退会者、非会員は除く）が検索対象となります。
            <br />
            ※会員番号、氏名は複数ユーザーで検索できます。キーワードは「,」（半角カンマ）区切りで入力・検索してください。
            <br />
            ※氏名の姓名の間のスペースは削除して入力・検索してください。
          </Typography>
          <Box mb={7}>
            <Paper>
              <Box p={3} mb={3}>
                <form onSubmit={(event: React.FormEvent<HTMLFormElement>) => handleSearch(event)}>
                  <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12} sm={2} md={2} xl={1} className={classes.searchLabel}>
                      <Typography variant="subtitle2">会員番号</Typography>
                    </Grid>
                    <Grid item xs={12} sm={10} md={10} xl={11} className={classes.searchItem}>
                      <Box>
                        <TextField
                          value={keyword.kaiin_no}
                          variant="outlined"
                          placeholder="会員番号を入力（複数の場合は半角カンマ区切り）"
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setKeyword({ ...keyword, kaiin_no: event.target.value })
                          }}
                          fullWidth
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12} sm={2} md={2} xl={1} className={classes.searchLabel}>
                      <Typography variant="subtitle2">氏名</Typography>
                    </Grid>
                    <Grid item xs={12} sm={10} md={10} xl={11} className={classes.searchItem}>
                      <Box>
                        <TextField
                          value={keyword.name}
                          variant="outlined"
                          placeholder="氏名を入力（姓名の間はスペース削除、複数の場合は半角カンマ区切り）"
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setKeyword({ ...keyword, name: event.target.value })
                          }}
                          fullWidth
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12} sm={2} md={2} xl={1} className={classes.searchLabel}>
                      <Typography variant="subtitle2">所属</Typography>
                    </Grid>
                    <Grid item xs={12} sm={10} md={10} xl={11} className={classes.searchItem}>
                      <Box>
                        <TextField
                          value={keyword.affiliation}
                          variant="outlined"
                          placeholder="所属を入力"
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setKeyword({ ...keyword, affiliation: event.target.value })
                          }}
                          fullWidth
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  {config.enableMessagesSearchMessageCount === '1' && (
                    <Grid container alignItems="center" spacing={3}>
                      <Grid item xs={12} sm={2} md={2} xl={1} className={classes.searchLabel}>
                        <Typography variant="subtitle2">メッセージ履歴</Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={10}
                        md={10}
                        xl={11}
                        alignItems="flex-start"
                        className={classes.searchItem}
                      >
                        <Box>
                          <CheckBoxes
                            options={checkedMessageCount}
                            chekedHandler={checked => {
                              setCheckedMessageCount(checked)
                              let checkedTrue = checked.filter(c => c.checked === true)
                              if (checkedTrue.length === 1) {
                                setKeyword({ ...keyword, message: checkedTrue[0].value })
                              } else {
                                setKeyword({ ...keyword, message: '' })
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                  <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12} sm={2} md={2} xl={1} className={classes.searchLabel}></Grid>
                    <Grid item xs={12} sm={10} md={10} xl={11} className={classes.searchItem}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                          <FormControlLabel
                            value="top"
                            control={
                              <Checkbox
                                checked={onlyUnreadFlg}
                                onChange={() => setOnlyUnreadFlg(!onlyUnreadFlg)}
                                value="only-unread-flg"
                              />
                            }
                            label="事務局の未読メッセージがあるユーザーのみを表示"
                            labelPlacement="end"
                          />
                        </FormGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12} sm={2} md={2} xl={1} className={classes.searchLabel}></Grid>
                    <Grid item xs={12} sm={10} md={10} xl={11} className={classes.searchItem}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                          <FormControlLabel
                            value="top"
                            control={
                              <Checkbox
                                checked={onlyUserUnreadFlg}
                                onChange={() => setOnlyUserUnreadFlg(!onlyUserUnreadFlg)}
                                value="only-unread-flg"
                              />
                            }
                            label="会員の未読メッセージがあるユーザーのみを表示"
                            labelPlacement="end"
                          />
                        </FormGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <Box mr={3}>
                      <Button variant="contained" color="primary" onClick={handleSearchReset}>
                        リセット
                      </Button>
                    </Box>
                    <Box>
                      <Button type="submit" variant="contained" color="primary">
                        検索
                      </Button>
                    </Box>
                  </Box>
                </form>
              </Box>
            </Paper>
          </Box>

          <Box ml={3} mr={2}>
            <Title>メッセージ送信対象の選択</Title>
            <Box mb={3}>
              <Typography variant="body1" paragraph>
                ユーザーに対してメッセージを送信することができます。{config.serviceName}
                の利用登録を完了したユーザーのみ（退会者、非会員は除く）が対象となります。
                <br />
                ・【特定のユーザーに対してメッセージを新規作成】チェックのあるユーザー（複数指定可）を送信対象とします。
                <br />
                ・【検索結果の全員に対してメッセージを新規作成】全ユーザー、または検索結果のユーザーを送信対象とします。
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Box display="flex">
                <Box mr={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCreateMessages}
                    disabled={selectUsers.length === 0}
                  >
                    特定のユーザーに対してメッセージを新規作成
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCreateMessagesForAllUsers}
                    disabled={users.length === 0}
                  >
                    検索結果の全員に対してメッセージを新規作成
                  </Button>
                </Box>
              </Box>
              <Box>
                <Button variant="contained" color="primary" onClick={handleMessageAllHistoryModal}>
                  すべてのメッセージ履歴
                </Button>
              </Box>
            </Box>
          </Box>

          <div id="top-of-list"></div>
          {config.enableMessagesFilterReset === '1' && (
            <Box display="flex" justifyContent="flex-end" alignItems="center" mt={5} mr={2}>
              <Badge
                className={classes.badge}
                badgeContent={<CancelIcon fontSize="small" />}
                invisible={!Object.values(filter).some(f => f)}
                max={0}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleFilterReset}
                  disabled={!Object.values(filter).some(f => f)}
                >
                  フィルターを解除
                </Button>
              </Badge>
            </Box>
          )}
          <Box>
            <Box display="flex" justifyContent="center">
              {currentPageCaption}
            </Box>
            <Box display="flex" justifyContent="center">
              <FlatPagination
                limit={limit}
                offset={(Number(initQuery.page || 1) - 1) * limit}
                total={total}
                onClick={(ev, offset, _page) => {
                  handlePageChange(_page)
                }}
              />
            </Box>
          </Box>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <Checkbox checked={allChecked} onChange={() => handleAllCheck()} />
                </TableCell>
                <TableCell align="center">
                  {config.enableMessagesFilterUnread === '1' ? (
                    <SelectInputTableHead
                      value={filter.unread}
                      label={'事務局未読'}
                      selectHandler={(select: string) => handleFilter('unread', select)}
                      options={[
                        { value: '', label: 'すべて表示' },
                        { value: '1', label: '事務局未読あり' },
                        { value: '0', label: '事務局未読なし' }
                      ]}
                    />
                  ) : (
                    '事務局未読'
                  )}
                </TableCell>
                <TableCell align="center">
                  {config.enableMessagesFilterUserUnread === '1' ? (
                    <SelectInputTableHead
                      value={filter.user_unread}
                      label={'会員未読'}
                      selectHandler={(select: string) => handleFilter('user_unread', select)}
                      options={[
                        { value: '', label: 'すべて表示' },
                        { value: '1', label: '会員未読あり' },
                        { value: '0', label: '会員未読なし' }
                      ]}
                    />
                  ) : (
                    '会員未読'
                  )}
                </TableCell>
                <TableCell>会員番号</TableCell>
                <TableCell>氏名</TableCell>
                <TableCell>メールアドレス</TableCell>
                <TableCell>所属</TableCell>
                <TableCell align="center">
                  {config.enableMessagesFilterMessageCount === '1' ? (
                    <SelectInputTableHead
                      value={filter.message}
                      label={'履歴'}
                      selectHandler={(select: string) => handleFilter('message', select)}
                      options={[
                        { value: '', label: 'すべて表示' },
                        { value: '1', label: 'メッセージ履歴あり' },
                        { value: '0', label: 'メッセージ履歴なし' }
                      ]}
                    />
                  ) : (
                    ''
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user, index) => (
                <TableRow key={user.id}>
                  <TableCell align="center">
                    <Checkbox
                      checked={selectUsers.some(selectUser => selectUser.id === user.id)}
                      onChange={() => handleCheck(user.id)}
                      value={user.id}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {user.unread > 0 && (
                      <Chip
                        label={`未読 ${user.unread}件`}
                        color="secondary"
                        onClick={() => {
                          saveQuery()
                          history.push(`/message-history/${user.kaiin_no}`)
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {user.user_unread > 0 ? (
                      <Typography
                        variant="inherit"
                        color="secondary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          saveQuery()
                          history.push(`/message-history/${user.kaiin_no}`)
                        }}
                      >
                        未読あり
                      </Typography>
                    ) : (
                      <Typography
                        variant="inherit"
                        color="initial"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          saveQuery()
                          history.push(`/message-history/${user.kaiin_no}`)
                        }}
                      >
                        未読なし
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="left">{user.kaiin_no}</TableCell>
                  <TableCell align="left">
                    <div>{`${user.name_last} ${user.name_first}`}</div>
                    {user.name_last_kana && (
                      <div>{`（${user.name_last_kana} ${user.name_first_kana}）`}</div>
                    )}
                  </TableCell>
                  <TableCell>{user.kaiin_email}</TableCell>
                  <TableCell align="left">{`${user.affiliation} ${user.position}`}</TableCell>
                  <TableCell align="center">
                    {user.kaiin_no && (
                      <Button
                        variant="contained"
                        color="primary"
                        href={`/message-history/${user.kaiin_no}`}
                        disabled={!user.message_count && true}
                        onClick={saveQuery}
                      >
                        メッセージ履歴
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Box my={4}>
            <Box display="flex" justifyContent="center">
              {currentPageCaption}
            </Box>
            <Box display="flex" justifyContent="center">
              <FlatPagination
                limit={limit}
                offset={(Number(initQuery.page || 1) - 1) * limit}
                total={total}
                onClick={(ev, offset, _page) => {
                  handlePageChange(_page)
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Grid>
      <CreateMessageModal
        users={storedUsers as User[]}
        isOpen={modalState}
        closeHandler={() => {
          closeHandler()
          setModalState(false)
        }}
        appName={appName}
      />
      <MessageAllHistoryModal
        isOpen={messageAllHistoryModalState}
        closeHandler={() => {
          setMessageAllHistoryModalState(false)
        }}
      />
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSearchQuery: (
      page: string,
      kaiin_no: string,
      name: string,
      affiliation: string,
      message: string,
      unread: boolean,
      user_unread: boolean,
      messagefilter: string,
      unreadfilter: string,
      user_unreadfilter: string
    ) =>
      dispatch(
        setSearchQueryMessages(
          page,
          kaiin_no,
          name,
          affiliation,
          message,
          unread,
          user_unread,
          messagefilter,
          unreadfilter,
          user_unreadfilter
        )
      ),
    unsetSearchQuery: () => dispatch(unsetSearchQueryMessages())
  }
}

const mapStateToProps = (state: ReturnType<typeof store.getState>) => {
  return {
    searchQuery: state.searchQueryMessages
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Messages)
